import {Button} from '@chekinapp/ui';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {useFetchIVLottie} from '@chekin/shared';
import {useReservation} from 'context/reservation';
import {useLayoutMode} from 'hooks/useLayoutMode';
import checkIcon from '../../../../assets/icons/check.svg?no-inline';
import {
  BottomBlock,
  HelpersBlock,
  HelpersItem,
  StyledLottieIVDocumentsAnimations,
  Wrapper,
} from './styled';
import {ModalTwoButtonsWrapper} from '@guestapp/old-ui-kit';

function SelfieInstructionsView() {
  const {t} = useTranslation('identity-verification');
  const navigate = useNavigate();
  const {housing} = useReservation();
  const layoutMode = useLayoutMode();
  const {animationData: ivLottieAnimation} = useFetchIVLottie({
    type: IV_DOCUMENT_IMAGE_TYPES.selfie,
  });

  return (
    <Wrapper className="iv-upload-type-view kiosko:w-[708px] kiosko:mt-16">
      <StyledLottieIVDocumentsAnimations
        loop
        animationData={ivLottieAnimation}
        className="kiosko:w-[708px] kiosko:h-auto"
      />
      <BottomBlock className="iv-upload-type-view__bottom kiosko:mt-14 kiosko:gap-y-[112px]">
        <HelpersBlock>
          {housing?.is_liveness_detection_enabled && layoutMode === 'default' && (
            <HelpersItem>
              <img src={checkIcon} width={24} height={24} alt="" />
              <p>{t('liveness_detection.helpers.keep_face_in_oval')}</p>
            </HelpersItem>
          )}
          <HelpersItem>
            <img
              src={checkIcon}
              width={24}
              height={24}
              alt=""
              className="kiosko:w-14 kiosko:h-auto"
            />
            <p>{t('liveness_detection.helpers.uncovered_face')}</p>
          </HelpersItem>
          <HelpersItem>
            <img
              src={checkIcon}
              width={24}
              height={24}
              alt=""
              className="kiosko:w-14 kiosko:h-auto"
            />
            <p>{t('liveness_detection.helpers.good_lighting')}</p>
          </HelpersItem>
        </HelpersBlock>
        <ModalTwoButtonsWrapper className="iv-upload-type-view__buttons">
          <Button
            variant="outline"
            onClick={() => {
              navigate(`../${PATHS.verification.selfie}`);
            }}
            size="md"
          >
            {t('understood')}
          </Button>
        </ModalTwoButtonsWrapper>
      </BottomBlock>
    </Wrapper>
  );
}

export {SelfieInstructionsView};
